import React, { useState } from "react";
import style from "./style.module.css";

// Reusable Tab Item Component
export const Tab = ({ name, children, className = "" }) => {
  return <div className={className}>{children}</div>;
};

// Tabs Container Component
const TabsComponent = ({ children, className = "", onTabChange }) => {
  const [activeTab, setActiveTab] = useState(children[0].props.name);
  const combinedClassName = `${style.innerBox} ${className}`;
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    onTabChange?.(tabName); // Notify parent if provided
  };
  return (
    <div className={combinedClassName}>
      <div className={style.tabHeader}>
        {children?.map((child) => (
          <button
            key={child?.props.name}
            // onClick={() => setActiveTab(child.props.name)}
            onClick={() => handleTabClick(child?.props.name)}
            className={
              activeTab === child?.props.name ? style.activeTab : style.tab
            }
          >
            {child?.props.name}
          </button>
        ))}
      </div>
      <div className={style.tabContent}>
        {/* <div className={style.content}> */}
        {children?.map((child) =>
          child?.props.name === activeTab ? child : null
        )}
        {/* </div> */}
      </div>
    </div>
  );
};

export default TabsComponent;
